import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { withStyles } from '@mui/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import styles from '../styles/file-uploader.less';
import { bindingsReady } from './bindings';
import { fetchApiSchema, emptyApiSchema } from './apiSchema';
import { hasNodeAttributes, inferNodeAttributes } from './inference';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = logger.createLogger('Layout');
function wrapper(body) {
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles['sharer']),
    children: [/*#__PURE__*/_jsxs("h5", {
      children: [/*#__PURE__*/_jsx("i", {
        children: "Optional"
      }), ": Set initial node positions using different graph layouts"]
    }), /*#__PURE__*/_jsx("br", {}), body]
  });
}
var RadioThemed = withStyles({
  colorPrimary: {
    '&$checked': {
      color: '#3f51b5'
    }
  },
  colorSecondary: {
    '&$checked': {
      color: '#3f51b5'
    }
  },
  checked: {}
})(Radio);
function makeAlgs(_ref) {
  var prefix = _ref.prefix,
    label = _ref.label,
    library = _ref.library;
  return function (_ref2) {
    var alg = _ref2.alg,
      options = _ref2.options,
      setLayoutAlg = _ref2.setLayoutAlg,
      disabled = _ref2.disabled;
    log.debug({
      options: options,
      alg: alg,
      disabled: disabled
    }, "activeAlgs: ".concat(prefix));
    if (disabled === undefined) {
      disabled = false;
    }
    return /*#__PURE__*/_jsx(Autocomplete, {
      options: options,
      value: alg ? alg.layout : undefined,
      filterSelectedOptions: true,
      disabled: disabled,
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
          variant: "outlined",
          label: label,
          placeholder: ""
        }));
      },
      onChange: function onChange(event, newValue) {
        log.debug({
          event: event,
          newValue: newValue
        }, 'alg change');
        setLayoutAlg({
          library: library,
          'layout': newValue
        });
      }
    });
  };
}
var CPULayoutAlgs = makeAlgs({
  prefix: 'i_',
  label: 'CPU (igraph) - may be slow',
  library: 'igraph'
});
var layouts = {
  'fa2': 'fa2',
  'alg': 'alg',
  'xy': 'xy',
  'umap': 'umap'
};
var handlers = {
  'fa2': {
    'setLayout': function setLayout(bindings) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        urlSettings: _objectSpread(_objectSpread({}, bindings.urlSettings), {}, {
          play: 5000
        })
      });
    },
    'clearLayout': function clearLayout(bindings) {
      return bindings;
    }
  },
  'xy': {
    'setLayout': function setLayout(bindings, xyX, xyY) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        urlSettings: _objectSpread(_objectSpread({}, bindings.urlSettings), {}, {
          play: 0
        }),
        nodeEncodings: _objectSpread(_objectSpread({}, bindings.nodeEncodings || {}), {}, {
          bindings: {
            node_x: xyX,
            node_y: xyY
          }
        })
      });
    },
    'clearLayout': function clearLayout(bindings) {
      var nodeBindingsUnpositioned = _objectSpread({}, (bindings.nodeEncodings || {}).bindings || {});
      if ('node_x' in nodeBindingsUnpositioned) {
        delete nodeBindingsUnpositioned.node_x;
      }
      if ('node_y' in nodeBindingsUnpositioned) {
        delete nodeBindingsUnpositioned.node_y;
      }
      return _objectSpread(_objectSpread({}, bindings), {}, {
        nodeEncodings: _objectSpread(_objectSpread({}, bindings.nodeEncodings || {}), {}, {
          bindings: nodeBindingsUnpositioned
        })
      });
    }
  },
  'alg': {
    'setLayout': function setLayout(bindings, alg) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        urlSettings: _objectSpread(_objectSpread({}, bindings.urlSettings), {}, {
          play: 0
        }),
        remote: _objectSpread(_objectSpread({}, bindings.remote), alg ? {
          layout: alg
        } : {})
      });
    },
    'clearLayout': function clearLayout(bindings) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        remote: _objectSpread(_objectSpread({}, bindings.remote), {}, {
          layout: {}
        })
      });
    }
  },
  'umap': {
    'setLayout': function setLayout(bindings) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        urlSettings: _objectSpread(_objectSpread({}, bindings.urlSettings), {}, {
          play: 0
        }),
        remote: _objectSpread(_objectSpread({}, bindings.remote), {}, {
          layout: {
            'library': 'pygraphistry',
            'layout': 'umap'
          }
        })
      });
    },
    'clearLayout': function clearLayout(bindings) {
      return _objectSpread(_objectSpread({}, bindings), {}, {
        remote: _objectSpread(_objectSpread({}, bindings.remote), {}, {
          layout: {}
        })
      });
    }
  }
};
function clearLayoutsExcept(bindings, layout) {
  var newBindings = bindings;
  Object.keys(handlers).filter(function (k) {
    return k != layout;
  }).forEach(function (k) {
    log.debug({
      k: k
    }, 'clearing layout');
    newBindings = handlers[k].clearLayout(newBindings);
  });
  if (layout === 'umap') {
    //set by Algorithms
    newBindings.remote.layout = _objectSpread({}, bindings.remote.layout);
  }
  return newBindings;
}
export function Layout(_ref3) {
  var visible = _ref3.visible,
    user = _ref3.user,
    files = _ref3.files,
    setVisualizationBindings = _ref3.setVisualizationBindings,
    visualizationBindings = _ref3.visualizationBindings,
    visualization = _ref3.visualization,
    layout = _ref3.layout,
    setLayout = _ref3.setLayout;
  var _useState = useState(emptyApiSchema()),
    _useState2 = _slicedToArray(_useState, 2),
    schema = _useState2[0],
    setSchema = _useState2[1];
  useEffect(function () {
    fetchApiSchema().then(function (v) {
      log.debug({
        v: v
      }, 'setting schema');
      if (v && v.layout) {
        setSchema(v);
      } else {
        log.warn({
          v: v
        }, 'Invalid schema response, using empty schema');
      }
    }).catch(function (e) {
      log.error({
        e: e
      }, 'Failed to fetch API schema, using empty schema');
    });
  }, []);
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    xyX = _useState4[0],
    setXyX = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    xyY = _useState6[0],
    setXyY = _useState6[1];
  var _useState7 = useState({
      'library': 'igraph',
      'layout': 'auto'
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    layoutAlg = _useState8[0],
    setLayoutAlg = _useState8[1];
  function handleLayoutToggle(layoutFresh) {
    log.debug({
      layout: layout,
      layoutFresh: layoutFresh,
      layoutAlg: layoutAlg,
      visualizationBindings: visualizationBindings
    }, 'layout handler');
    if (layout != layoutFresh) {
      setLayout(layoutFresh);
    }
    var clearedBindings = clearLayoutsExcept(visualizationBindings, layoutFresh);
    var newBindings = clearedBindings;
    switch (layoutFresh) {
      case layouts.fa2:
        newBindings = handlers[layoutFresh].setLayout(clearedBindings);
        break;
      case layouts.xy:
        newBindings = handlers[layoutFresh].setLayout(clearedBindings, xyX, xyY);
        break;
      case layouts.alg:
        newBindings = handlers[layoutFresh].setLayout(clearedBindings, layoutAlg);
        break;
      case layouts.umap:
        newBindings = handlers[layoutFresh].setLayout(clearedBindings);
        break;
      default:
        log.warn("Layout not yet implemented: ".concat(layoutFresh));
    }
    if (JSON.stringify(newBindings) != JSON.stringify(visualizationBindings)) {
      log.debug({
        newBindings: newBindings,
        visualizationBindings: visualizationBindings
      }, 'layout changed visualization bindings');
      setVisualizationBindings(newBindings);
    }
  }
  useEffect(function () {
    handleLayoutToggle(layout);
  }, [xyX, xyY, layoutAlg]); // do not track layout as handled directly (here) + indirectly (umap)
  // tracking here risks a loop

  if (!visible) {
    return null;
  }
  log.debug({
    schema: schema,
    user: user,
    files: files,
    visualizationBindings: visualizationBindings,
    visualization: visualization
  }, 'Layout');
  var _bindingsReady = bindingsReady({
      files: files,
      visualizationBindings: visualizationBindings
    }),
    isReady = _bindingsReady.isReady,
    message = _bindingsReady.message;
  if (!isReady || !visualization.dataset_id) {
    return /*#__PURE__*/_jsx(Card, {
      className: "".concat(styles['sharer-fail-message']),
      children: /*#__PURE__*/_jsx(Card.Title, {
        children: !isReady ? 'Please finish configuring visualization first' : 'Visualization uploading...'
      })
    });
  }
  return wrapper(/*#__PURE__*/_jsx("div", {
    className: styles['cleaner'],
    children: /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsxs(RadioGroup, {
        "aria-label": "graph-layout",
        value: layout,
        name: "graph-layout-group",
        onChange: function onChange(event) {
          return handleLayoutToggle(event.target.value);
        },
        children: [/*#__PURE__*/_jsxs(Card, {
          className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(true ? 'enabled' : 'disabled')]),
          children: [/*#__PURE__*/_jsx(Card.Header, {
            className: styles['shaper-header'],
            children: /*#__PURE__*/_jsx(FormControlLabel, {
              value: layouts.fa2,
              control: /*#__PURE__*/_jsx(RadioThemed, {}),
              label: "ForceAtlas2 - Recommended default"
            })
          }), /*#__PURE__*/_jsxs(Card.Body, {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["Position nodes using Graphistry's GPU-accelerated implementation of ", /*#__PURE__*/_jsx("a", {
                href: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4051631",
                target: "_blank",
                children: "ForceAtlas2"
              }), ". Nodes with many edges between them are placed near one another, while nodes with few or no edges in common will go further apart."]
            }), /*#__PURE__*/_jsx("p", {
              children: "ForceAtlas2 is tuned for organic graphs like social networks, ML correlations, and behavioral analysis. It is responsive on up to to about 500K nodes / 2M edges. It also gets used during live interactions with the graph that trigger re-clustering nodes."
            })]
          })]
        }), /*#__PURE__*/_jsxs(Card, {
          className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(true ? 'enabled' : 'disabled')]),
          children: [/*#__PURE__*/_jsx(Card.Header, {
            className: styles['shaper-header'],
            children: /*#__PURE__*/_jsx(FormControlLabel, {
              value: layouts.xy,
              control: /*#__PURE__*/_jsx(RadioThemed, {}),
              label: /*#__PURE__*/_jsxs(_Fragment, {
                children: ["Use 2 existing columns for node position x, y values", hasNodeAttributes(visualizationBindings) ? null : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("small", {
                    children: "Requires a nodes file or enriching algorithms"
                  })]
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Card.Body, {
            children: function () {
              var attributes = inferNodeAttributes(visualizationBindings);
              var hasNodes = hasNodeAttributes(visualizationBindings);
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Autocomplete, {
                  options: attributes,
                  value: xyX,
                  filterSelectedOptions: true,
                  disabled: layout != layouts.xy || !hasNodes,
                  renderInput: function renderInput(params) {
                    return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
                      variant: "outlined",
                      label: 'x column',
                      placeholder: ""
                    }));
                  },
                  onChange: function onChange(event, newValue) {
                    log.debug({
                      event: event,
                      newValue: newValue
                    }, 'xyX');
                    setXyX(newValue);
                  }
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Autocomplete, {
                  options: attributes,
                  value: xyY,
                  filterSelectedOptions: true,
                  disabled: layout != layouts.xy || !hasNodes,
                  renderInput: function renderInput(params) {
                    return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
                      variant: "outlined",
                      label: 'y column',
                      placeholder: ""
                    }));
                  },
                  onChange: function onChange(event, newValue) {
                    log.debug({
                      event: event,
                      newValue: newValue
                    }, 'xyY');
                    setXyY(newValue);
                  }
                })]
              });
            }()
          })]
        }), /*#__PURE__*/_jsxs(Card, {
          className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(true ? 'enabled' : 'disabled')]),
          children: [/*#__PURE__*/_jsx(Card.Header, {
            className: styles['shaper-header'],
            children: /*#__PURE__*/_jsx(FormControlLabel, {
              value: layouts.alg,
              control: /*#__PURE__*/_jsx(RadioThemed, {}),
              label: "Layout"
            })
          }), /*#__PURE__*/_jsxs(Card.Body, {
            children: [/*#__PURE__*/_jsx(CPULayoutAlgs, {
              alg: layoutAlg,
              options: schema.layout.igraph,
              setLayoutAlg: setLayoutAlg,
              disabled: layout != layouts.alg
            }), /*#__PURE__*/_jsxs("p", {
              children: ["Learn about the different ", /*#__PURE__*/_jsx("a", {
                href: "https://igraph.org/c/doc/igraph-Layout.html",
                target: "blank",
                children: "layouts"
              }), "."]
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx("i", {
                children: "Tip: Sugiyama is popular for smaller graphs but may timeout on bigger graphs."
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs(Card, {
          className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(true ? 'enabled' : 'disabled')]),
          children: [/*#__PURE__*/_jsx(Card.Header, {
            className: styles['shaper-header'],
            children: /*#__PURE__*/_jsx(FormControlLabel, {
              value: layouts.umap,
              control: /*#__PURE__*/_jsx(RadioThemed, {}),
              label: "UMAP"
            })
          }), /*#__PURE__*/_jsxs(Card.Body, {
            children: [/*#__PURE__*/_jsx("p", {
              children: "Use node positions computed by UMAP based on node attribute similarities."
            }), /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsx("i", {
                children: "Note:"
              }), " If also uploading edges, UMAP will also consider edge linkages when computing node positions, not just regular node attributes. (Edge attributes are not incorporated.) Subsequent ForceAtlas2 live re-layouts will likewise incorporate both UMAP-generated node similarity edges and uploaded edges."]
            })]
          })]
        })]
      })
    })
  }));
}